import { useEffect } from "react";
import { useSettings } from "@/context/SettingsContext";

export default function About() {
  const { settings } = useSettings();
  const a = settings?.about || {};
  const c = settings?.contact || {};
  useEffect(() => { if (settings?.seo?.about_title) document.title = settings.seo.about_title; }, [settings]);
  return (
    <div className="max-w-3xl mx-auto px-6 py-16">
      <div className="text-center mb-10">
        <p className="font-caption text-brass text-xs mb-2">About</p>
        <h1 className="font-display text-4xl sm:text-6xl text-gold" data-testid="about-heading">{a.heading || "About Golden Moth Market"}</h1>
      </div>
      <div className="prose prose-invert text-parchment/80 space-y-6">
        {a.intro && <p className="text-lg italic">{a.intro}</p>}
        {a.body && <p>{a.body}</p>}
      </div>

      <div id="policies" className="mt-16 pt-10 border-t border-brass-soft space-y-4">
        <h2 className="font-display text-2xl text-gold">{a.supporting_heading || "Policies"}</h2>
        <p className="text-parchment/70 text-sm">Shipping, returns, and care information will be added by the proprietor.</p>
      </div>

      <div id="contact" className="mt-16 pt-10 border-t border-brass-soft space-y-3">
        <h2 className="font-display text-2xl text-gold">{c.heading || "Contact the Proprietor"}</h2>
        {c.intro && <p className="text-parchment/80">{c.intro}</p>}
        {c.supporting && <p className="text-parchment/60 text-sm italic">{c.supporting}</p>}
      </div>
    </div>
  );
}
